/**
 * What the learning editor starts with, read from the chat's diagnosis state (tse:diag_state, as the brain panel holds it):
 *   category   the diagnosis' category (shown, not chosen); its label comes from the panel's category bundle when it has one
 *   symptoms   the symptoms the engineer confirmed (a denied or unknown one is left out), and what was noted from their words
 *   steps      the checks that were run (done or failed) for the leading cause, in the order the diagnosis lists them
 * The engineer edits all of it; an empty list shows one blank row. Pure function, safe on a missing or partial state.
 */
const SYMPTOM_PREFIX = "SYM_";
const NOT_PRESENT = new Set(["no", "unknown"]);
const LEADING = new Set(["leading", "confirmed"]);
const RAN = new Set(["done", "failed"]);
const list = (v) => (Array.isArray(v) ? v : []);
const text = (v) => String(v || "").trim();

export function sessionFromDiag(diagState, categoryLabel = "") {
  const ds = diagState || {};
  const symptoms = list(ds.observed)
    .filter((f) => f && String(f.id).startsWith(SYMPTOM_PREFIX) && !NOT_PRESENT.has(f.value)).map((f) => text(f.label));
  const noted = list(ds.noted).map((n) => text(n && n.text));
  const causes = list(ds.causes);
  const leader = causes.find((c) => c && LEADING.has(c.status)) || causes[0];
  const steps = list(leader && leader.checks).filter((c) => c && RAN.has(c.status)).map((c) => text(c.text));
  const key = text(ds.category);
  return {
    category: key ? { key, label: text(categoryLabel) || key } : null,
    symptoms: [...symptoms, ...noted].filter(Boolean),
    steps: steps.filter(Boolean),
  };
}
